import React from "react";

import * as m from "@/shared/styles/main.module.scss";
import chart from "../../assets/images/chart.svg";

const Header: React.FC = () => {
  return (
    <div className={m.header}>
      <div className={`${m.logoWrapper} ${m.wrapper}`}>
        <a
          href={window.location.origin}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={chart} alt="chart" />
          <span>SatisfactionStats</span>
        </a>
      </div>
    </div>
  );
};

export default Header;
